import { Action, createReducer, on } from '@ngrx/store';
import * as DatasetsActions from '../actions';
import { IMetadataTags } from '../../models/Metadata-tags';

export interface MetadataTagsState {
  metadataTags: IMetadataTags[];
}

const initialState: MetadataTagsState = {
  metadataTags: [],
};

export const metadataTagsReducer = createReducer(
  initialState,
  on(DatasetsActions.MetadataTagsUiActions.GetMetadataTags, (state) => ({
    ...state,
  })),
  on(DatasetsActions.MetadataTagsApiActions.getMetadataTagsSuccess, (state, { payload }) => ({
    ...state,
    metadataTags: payload,
  })),
  on(DatasetsActions.MetadataTagsApiActions.getMetadataTagsError, (state) => ({
    ...state,
    metadataTags: [],
  })),
  on(DatasetsActions.MetadataTagsUiActions.PostMetadataTags, (state) => ({
    ...state,
  })),
  on(DatasetsActions.MetadataTagsApiActions.postMetadataTagsSuccess, (state) => ({
    ...state,
  })),
  on(DatasetsActions.MetadataTagsApiActions.postMetadataTagsError, (state) => ({
    ...state,
  })),
  on(DatasetsActions.MetadataTagsUiActions.DeleteMetadataTags, (state) => ({
    ...state,
  })),
  on(DatasetsActions.MetadataTagsApiActions.deleteMetadataTagsSuccess, (state) => ({
    ...state,
  })),
  on(DatasetsActions.MetadataTagsApiActions.deleteMetadataTagsError, (state) => ({
    ...state,
  }))
);

export function MetadataTagsReducer(state: MetadataTagsState | undefined, action: Action) {
  return metadataTagsReducer(state, action);
}
